import { useTranslation } from 'react-i18next';
import ProjectRows from '../components/project/ProjectRows/ProjectRows';
import PageHero from '../components/ui/PageHero/PageHero';
import PillLink from '../components/ui/PillLink/PillLink';
import Section from '../components/ui/Section/Section';
import { CONTACT_EMAIL } from '../data/navigation';
import { projects } from '../data/projects';
import { usePageMeta } from '../hooks/usePageMeta';
import { useLanguage } from '../i18n/useLanguage';
import styles from './Support.module.css';

const supportedProjects = projects.filter((project) => project.ownership !== 'clientWork' && project.links.length > 0);

export default function Support() {
    const { t } = useTranslation();
    const { localizedPath } = useLanguage();
    usePageMeta(t('meta.supportTitle'), t('meta.supportDescription'));

    const checklist = t('support.checklist', { returnObjects: true }) as unknown as string[];

    return (
        <>
            <PageHero title={t('support.title')} lead={t('support.lead')}>
                <PillLink href={`mailto:${CONTACT_EMAIL}`} size="large" icon="arrowRight">{t('support.action', { email: CONTACT_EMAIL })}</PillLink>
            </PageHero>

            <Section theme="light" shape="sheet">
                <div className={`page-inner ${styles.layout}`}>
                    <section aria-labelledby="support-checklist-title" className={styles.block}>
                        <h2 id="support-checklist-title" className={styles.title}>{t('support.checklistTitle')}</h2>
                        <ul className={styles.checklist}>
                            {checklist.map((entry) => <li key={entry}>{entry}</li>)}
                        </ul>
                    </section>

                    <section aria-labelledby="support-apps-title" className={styles.block}>
                        <h2 id="support-apps-title" className={styles.title}>{t('support.appsTitle')}</h2>
                        <ProjectRows projects={supportedProjects} />
                    </section>

                    <section aria-labelledby="support-privacy-title" className={`${styles.block} ${styles.privacy}`}>
                        <h2 id="support-privacy-title" className={styles.title}>{t('support.privacyTitle')}</h2>
                        <p className={styles.privacyBody}>{t('support.privacyBody')}</p>
                        <PillLink href={localizedPath('/privacy-policy')} variant="outline" icon="arrowRight">{t('support.privacyLink')}</PillLink>
                    </section>
                </div>
            </Section>
        </>
    );
}
